/* ==========================================================================
   VAT-exempt popup ↔ sidebar cart (custom)
   Loaded on every page from layout/theme.liquid (gated by
   settings.vat_exempt_app_enabled), because the drawer cart is global.

   The checkout click flow itself is owned by the VAT Exemption app (Milople):
   its vat-form.js has a CoolCrutches-only window capture listener on
   #coolcrutches-checko / #coolcrutches-drawer-checko that verifies eligibility
   and either goes to /checkout or opens #vatFormPopup — itself, or by handing
   over to the inline click handler in layout/theme.liquid.

   Neither of those closes Prestige's #sidebar-cart (the app only looks for
   Dawn-style drawers), so the popup opened over the still-open drawer and the
   drawer's focus trap kept pulling focus off the form fields. Rather than hook
   every opener, watch the popup and close the drawer whenever it becomes
   visible — independent of which script opened it or in what order.
   ========================================================================== */
(function () {
  // Bind guard: never stack observers if the script is included twice.
  if (window.__ccVatPopupDrawerBound) return;
  window.__ccVatPopupDrawerBound = true;

  // Flip to true to trace in the console.
  var DEBUG = false;
  function vlog() {
    if (!DEBUG) return;
    var args = Array.prototype.slice.call(arguments);
    console.log.apply(console, ['[VAT-popup]'].concat(args));
  }

  function isDrawerOpen() {
    var drawer = document.getElementById('sidebar-cart');
    return !!drawer && drawer.getAttribute('aria-hidden') === 'false';
  }

  // Close the sidebar drawer via the theme's own close action (cleans up the
  // focus trap + page overlay). Do NOT blanket-hide generic overlays — the app
  // popup uses its own.
  function closeDrawer() {
    var closeBtn = document.querySelector('[data-action="close-drawer"][data-drawer-id="sidebar-cart"]');
    if (closeBtn) {
      vlog('closing drawer via close-drawer action');
      closeBtn.click();
      return;
    }
    vlog('close-drawer action not found; closing drawer manually');
    var drawer = document.getElementById('sidebar-cart');
    if (drawer) drawer.setAttribute('aria-hidden', 'true');
    var pageOverlay = document.querySelector('.PageOverlay');
    if (pageOverlay) pageOverlay.classList.remove('is-visible');
  }

  // Every opener (app or theme) shows the popup by setting its inline style,
  // so a style-attribute observer catches them all.
  function watchPopup(popup) {
    new MutationObserver(function () {
      if (!isDrawerOpen()) return;
      if (window.getComputedStyle(popup).display === 'none') return;
      closeDrawer();
    }).observe(popup, { attributes: true, attributeFilter: ['style'] });
    vlog('observer bound');
  }

  var popup = document.getElementById('vatFormPopup');
  if (popup) {
    watchPopup(popup);
    return;
  }

  // The app embed normally renders the popup server-side; if it isn't on the
  // page yet, wait for it rather than silently leaving the drawer unhandled.
  vlog('no #vatFormPopup yet — waiting for it');
  var waitForPopup = new MutationObserver(function () {
    var el = document.getElementById('vatFormPopup');
    if (!el) return;
    waitForPopup.disconnect();
    watchPopup(el);
  });
  waitForPopup.observe(document.body, { childList: true, subtree: true });
})();
